import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <div className="text-center space-y-4">
      {/* Logo */}
      <Link to="/dashboard" className="inline-flex items-center space-x-3">
        <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-lg">
          <Icon name="PenTool" size={24} color="white" />
        </div>
        <span className="text-2xl font-heading font-bold text-foreground">
          PenGame PR Hub
        </span>
      </Link>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-3xl font-heading font-bold text-foreground">
          Create Your Account
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Join thousands of publishing professionals who trust PenGame PR Hub for their media outreach and content creation needs.
        </p>
      </div>

      {/* Key Benefits */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="Sparkles" size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-foreground">AI-Powered Content</h3>
          <p className="text-xs text-muted-foreground text-center">
            Generate press releases, social posts, and pitches in minutes
          </p>
        </div>
        
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center">
            <Icon name="Users" size={20} className="text-secondary" />
          </div>
          <h3 className="text-sm font-medium text-foreground">Media Database</h3>
          <p className="text-xs text-muted-foreground text-center">
            Access thousands of verified media contacts and journalists
          </p>
        </div>
        
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-accent/10 rounded-full flex items-center justify-center">
            <Icon name="BarChart3" size={20} className="text-accent" />
          </div>
          <h3 className="text-sm font-medium text-foreground">Real-Time Analytics</h3>
          <p className="text-xs text-muted-foreground text-center">
            Track campaign performance and media coverage insights
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationHeader;